module.exports = __webpack_public_path__ + "static/media/download.77c4e933.svg";